import PluginDecorator from './PluginDecorator';
import {PlayerComponentHookType} from "../../components/wrappers/PlayerComponentWrapper";
import mergeOptions from "../../utils/wrappers/merge-options";

// load plugin
import "videojs-hotkeys";

export default class HotKeysPluginDecorator extends PluginDecorator{

    static readonly PLUGIN_NAME = 'hotkeys';

    static bootingStaticApi() {
        super.bootingStaticApi();
        this.hookManagerInstance.add<PlayerComponentHookType>('BEFORE_SETUP', (videoEl: Element, options: any) => {
            return this.processOptions(options);
        });
    }

    static processOptions(options: any) {
        
        options.plugins.hotkeys = options.plugins.hotkeys || {};

        // extend default configuration with custom configuration
        options.plugins.hotkeys = mergeOptions({},{
            volumeStep: 0.1,
            seekStep: 5,
            enableModifiersForNumbers: false,
            enableVolumeScroll: false   // deactivate scrolling event for volume,
                                        // because the scrolling of page should not be deactivated, when the cursor is over the player
        },options.plugins.hotkeys);

        return options;
    }

}


// WEBPACK FOOTER //
// ./src/app/plugins/decorators/HotKeysPluginDecorator.ts